import React from 'react';
import { useParams } from 'react-router';
import { AdminLayout } from 'apps/sigma2-ui/src/components/AdminLayout';
import { AdminBreadcrumbs } from 'apps/sigma2-ui/src/components/ui/AdminBreadcrumbs';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { SubTabs } from 'apps/sigma2-ui/src/components/ui/SubTabs';
import { SubTabsHeader } from 'apps/sigma2-ui/src/components/ui/SubTabs';
import { useSubTabs } from 'apps/sigma2-ui/src/lib/hooks/useSubTabGroup';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { OrganizationStreamlitAppsSection } from 'apps/sigma2-ui/src/organizations/components/OrganizationStreamlitAppsSection';
import { OrganizationDagsterTransformSection } from 'apps/sigma2-ui/src/organizations/components/OrganizationDagsterTransformSection';

export const OrganizationEntitlementsPage: React.FC = () => {
  const { organizationId } = useParams();
  const language = useLanguage();

  const tabProps = useSubTabs({
    initialSelectedTabIndex: 0,
    tabDefinitions: [
      {
        header: ({ isSelected }) => (
          <SubTabsHeader
            isSelected={isSelected}
            translatedContent="Streamlit Apps"
          />
        ),
        body: () => (
          <OrganizationStreamlitAppsSection
            organizationId={organizationId ?? ''}
          />
        ),
      },
      {
        header: ({ isSelected }) => (
          <SubTabsHeader
            isSelected={isSelected}
            translatedContent="Dagster Transform"
          />
        ),
        body: () => (
          <OrganizationDagsterTransformSection
            organizationId={organizationId ?? ''}
          />
        ),
      },
    ],
  });

  if (!organizationId) {
    return (
      <AdminLayout currentPage={'OrganizationEdit'}>
        <S2Typography
          variant="headline-4"
          translatedContent="Organization not found"
        />
      </AdminLayout>
    );
  }

  return (
    <AdminLayout currentPage={'OrganizationEdit'}>
      <AdminBreadcrumbs
        items={[
          { label: 'Home', to: '/admin' },
          { label: 'Organizations', to: '/organizations' },
          {
            label: 'Manage Entitlements',
            to: `/organizations/${organizationId}/entitlements`,
          },
        ]}
      />
      <Spacing size={'md'} direction={'vertical'}>
        <S2Typography
          translatedContent={language.manageOrganizationEntitlements()}
          variant="headline-4"
        />
        <S2Typography
          translatedContent={language.manageOrganizationEntitlementsDescription()}
          variant="body-6"
        />

        <div className="mt-6">
          <SubTabs {...tabProps} />
        </div>
      </Spacing>
    </AdminLayout>
  );
};
